import { message } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';
import api from '../../../Api';
import * as Util from '../../../util';
import makeConnectTo from '../../util/makeConnectTo';

const SavedFiltersContext = React.createContext();

export const useSavedFilters = () => React.useContext(SavedFiltersContext);

const name = 'savedFiltersDataStore';

export const connectToSavedFilters = makeConnectTo(SavedFiltersContext, name);

export default class SavedFiltersDataStore extends React.Component {
	static propTypes = {
		children: PropTypes.oneOfType([PropTypes.element, PropTypes.func]),
	};

	state = {
		savedFilters: [],
		filtersByType: [],
		isLoading: true,
	};

	render() {
		const savedFiltersDataStore = this.getStore();
		return (
			<SavedFiltersContext.Provider value={savedFiltersDataStore}>
				{typeof this.props.children === 'function'
					? this.props.children(savedFiltersDataStore)
					: this.props.children}
			</SavedFiltersContext.Provider>
		);
	}

	componentDidMount() {
		this.fetchSavedFilters();
	}

	componentWillUnmount() {
		if (this.savedFiltersFetch && this.savedFiltersFetch.cancel) {
			this.savedFiltersFetch.cancel();
		}
	}

	getStore = (state = this.state) => ({
		state,
		refresh: () => this.refreshSavedFilters(),
		deleteSavedFilter: id => this.deleteSavedFilter(id),
		saveNewFilter: name => this.saveNewFilter(name),
	});

	refreshSavedFilters = doNotRefresh => {
		!doNotRefresh &&
			this.setState({
				isLoading: true,
			});
		this.fetchSavedFilters();
		return this.savedFiltersFetch.promise;
	};

	fetchSavedFilters = () => {
		const request = api.cancelableGet(`/api/v1/savedFilters`);
		request.promise.then(this.cacheApiResponse);
		this.savedFiltersFetch = request;
	};

	cacheApiResponse = apiResponse => {
		const savedFilters = this.getSavedFilters(apiResponse).sort(function(
			a,
			b,
		) {
			return a.name.localeCompare(b.name);
		});
		savedFilters.push({
			id: -1,
			browseRefinements: [],
			name: `My Filter #` + (savedFilters.length + 1),
			filtersByType: [],
			definition: '',
		});
		this.setState({ savedFilters, isLoading: false });
	};

	getSavedFilters = apiResponse => {
		return apiResponse.map(savedFilter => {
			return {
				...savedFilter,
				filtersByType: savedFilter.browseRefinements
					? Object.keys(
							Util.groupBy(
								savedFilter.browseRefinements,
								'browseLaneType',
							),
					  )
					: [],
			};
		});
	};

	deleteSavedFilter = id => {
		const body = {
			id: id,
		};
		const endpoint = `/api/v1/savedFilters`;
		this.messagesFetch = api.cancelableCall('DELETE', endpoint, body);
		message.success('This filter has been deleted');
		return this.messagesFetch.promise.then(() =>
			this.refreshSavedFilters(false),
		);
	};

	saveNewFilter = name => {
		const userBrowseView = {
			name: name,
			definition: '{}',
		};
		api.post('/api/v1/savedFilters', userBrowseView).then(() => {
			this.refreshSavedFilters(false);
			message.success('Your new filter has been saved');
		});
		console.log(userBrowseView);
	};
}
